import { ColorEnum } from '@/constants/color'
import IconButton from '@/features/ui/buttons/components/IconButton'
import Dropdown from '@/features/ui/components/Dropdown'
import MoreVertIcon from '@/features/ui/icons/components/MoreVertIcon'
import { FC, ReactNode } from 'react'
import { StyleSheet } from 'react-native'

interface MenuButtonProps {
    children: ReactNode
    open: boolean
    onToggleOpen: () => void
}

const MenuButton: FC<MenuButtonProps> = ({ children, open, onToggleOpen }) => {
    return (
        <Dropdown
            visible={open}
            preferredPosition="above"
            contentWidth="content"
            Anchor={
                <IconButton
                    Icon={MoreVertIcon}
                    type="outline"
                    color="secondary"
                    size={44}
                    onPress={onToggleOpen}
                />
            }
            ItemList={children}
            onClose={onToggleOpen}
            contentStyle={styles.dropdownContent}
        />
    )
}

const styles = StyleSheet.create({
    dropdownContent: {
        overflow: 'hidden',
        boxShadow: `0px 4px 4px 0px ${ColorEnum.GRAY_300}`,
        elevation: 4,
        shadowColor: ColorEnum.GRAY_300,
        shadowOffset: { width: 0, height: 4 },
        shadowRadius: 4,
        shadowOpacity: 1,
    },
})

export default MenuButton
